import {
  Label,
  Card,
  CardBody,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Button,
  CardTitle,
} from 'reactstrap';
import Select from 'react-select';
import { Formik, Form, Field } from 'formik';
import Spin from 'antd/lib/spin';
import { LoadingOutlined } from '@ant-design/icons';
import { createUseStyles } from 'react-jss';
import ChargingSessionsTable from 'components/Reusable/ChargingSessionsTable';
import 'antd/lib/table/style/index.css';
import 'antd/lib/popover/style/index.css';
import { useHostChargersForAllPeriods } from 'utils/queries/hostQueries';
import { useEffect, useState } from 'react';
import { findIndex, map, uniq } from 'lodash';
import moment from 'moment';
import './style.scss';

const useStyles = createUseStyles({
  antSpinner: {
    color: 'black',
    '& .ant-spin-dot-item': {
      backgroundColor: '#2675b8',
    },
  },
  searchButton: {
    height: '43px',
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    fontWeight: 'normal',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

const Analytics = () => {
  const classes = useStyles();
  const initialFormValues = {
    chargers: [],
    startDate: moment().startOf('month').format('yyyy-MM-DD'),
    endDate: moment().endOf('month').format('yyyy-MM-DD'),
    states: [],
  };
  const [searchParams, setSearchParams] = useState(null);
  const [optionsChargers, setOptionsChargers] = useState([]);
  const [optionsStates, setOptionsStates] = useState([]);
  const { data: chargers } = useHostChargersForAllPeriods();

  const getChargingSessions = (values, setSubmitting) => {
    const request = { ...values };
    request.chargers = uniq(map(values.chargers, 'value'));
    request.startDate = moment(values.startDate).format('DD-MM-YYYY');
    request.endDate = moment(values.endDate).format('DD-MM-YYYY');
    request.states = uniq(map(values.states, 'value'));
    setSearchParams(request);
  };

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    const formValue = { ...initialFormValues };
    formValue.startDate = moment().startOf('month').format('DD-MM-YYYY');
    formValue.endDate = moment().endOf('month').format('DD-MM-YYYY');
    setSearchParams(formValue);
  }, []);

  const getChargerLabel = (charger) => {
    return (
      <div>
        <div>{charger.ID}</div>
        <div style={{ fontSize: 12, color: '#8898aa' }}>{charger.ADDRESS}</div>
      </div>
    );
  };

  useEffect(() => {
    if (chargers?.length > 0) {
      const chargerOptions = [];
      const stateOptions = [];
      chargers.forEach((charger) => {
        chargerOptions.push({
          value: charger.ID,
          label: getChargerLabel(charger),
        });
        const stateOption = { value: charger.STATE, label: charger.STATE };
        if (findIndex(stateOptions, stateOption) === -1) {
          stateOptions.push(stateOption);
        }
      });
      setOptionsChargers(chargerOptions);
      setOptionsStates(stateOptions);
    }
  }, [chargers]);

  return (
    <div className="analytics">
      <Container className="mt-7" fluid>
        <Spin
          spinning={false}
          size="large"
          className={classes.antSpinner}
          indicator={<LoadingOutlined style={{ color: '#2675b8' }} />}
        >
          <Card className="shadow" style={{ marginBottom: 20 }}>
            <CardBody>
              <CardTitle tag="h3">Analytics</CardTitle>
              <hr className="my-3" />
              <Formik
                initialValues={initialFormValues}
                onSubmit={(values, { resetForm, setSubmitting }) => {
                  getChargingSessions(values, setSubmitting);
                }}
              >
                {({ values, isSubmitting, setFieldValue }) => (
                  <Form>
                    <div className="pl-lg-4 pr-lg-4 ">
                      <Row>
                        <Col md={3}>
                          <FormGroup>
                            <Label for="chargers">Chargers</Label>
                            <Field
                              component={Select}
                              name="chargers"
                              isMulti
                              options={optionsChargers}
                              onChange={(e, h) => {
                                setFieldValue('chargers', e);
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                              // className="form-control"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <Label for="startDate">Start Date</Label>
                            <Field
                              component={Input}
                              name="startDate"
                              type="date"
                              defaultValue={values?.startDate}
                              onChange={(e) =>
                                setFieldValue('startDate', e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <Label for="endDate">End Date</Label>
                            <Field
                              component={Input}
                              name="endDate"
                              type="date"
                              defaultValue={values?.endDate}
                              onChange={(e) =>
                                setFieldValue('endDate', e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <Label for="states">States</Label>
                            <Field
                              component={Select}
                              name="states"
                              isMulti
                              options={optionsStates}
                              onChange={(e) => setFieldValue('states', e)}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12} className="text-center">
                          <Button
                            type="submit"
                            className={classes.searchButton}
                          >
                            Search
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
          <ChargingSessionsTable chargingSessionsParams={searchParams} />
        </Spin>
      </Container>
    </div>
  );
};

export default Analytics;
